@if (!loading()) {
  <nb-accordion class="noselect">
    @for (group of groups(); track group) {
      <nb-accordion-item [expanded]="group.checkpointGroupId === selectedGroupId()"
                         (collapsedChange)="collapseChange($event, group)">
        <nb-accordion-item-header>
          {{ group.checkpointGroupNumber }} {{ group.checkpointGroupName }}
          @if (!disabled()) {
            <div class="actions">
              <div class="actions-absolute">
                <button nbButton
                        ghost
                        (click)="deleteGroupClick($event, group)"
                        nbTooltip="Gruppe Löschen">
                  <nb-icon icon="trash-2-outline" pack="eva"></nb-icon>
                </button>
              </div>
            </div>
          }
        </nb-accordion-item-header>
        <nb-accordion-item-body class="no-padding">
          @for (inspectionEntry of group.entries; track inspectionEntry.controls.id) {
            <wr-inspection-entry-list-item
              [inspectionEntry]="inspectionEntry"
              [selected]="selectedEntry() === inspectionEntry"
              [canEdit]="canEdit()"
              (click)="selectedEntry$.emit(inspectionEntry)"
              (markPostProcessingDone)="markPostProcessingDone.emit(inspectionEntry)">
            </wr-inspection-entry-list-item>
          }
        </nb-accordion-item-body>
      </nb-accordion-item>
    }
  </nb-accordion>
} @else {
  <div class="spinner-container" [nbSpinner]="true"></div>
}
